import {FC} from "react";
import styled from "styled-components";
import {StatusListFragment} from "../StatusList/__generated__/StatusList.fragment.generated";


const Container = styled.div`
  padding: 2.4rem;
  line-height: 130%;
  margin-top: -2.4rem;
  margin-left: -2.4rem;
  background: #e6ebef;
  margin-bottom: 2.5rem;
  width: calc(100% + 4.8rem);
`;


interface CategoryInformProps {
  info: StatusListFragment
}

const StatusInform:FC<CategoryInformProps> = ({ info }) => {
  return (
      <Container>
        <p>Информация о статусе:</p>
        <h2>{info.title}</h2>
        <p>TYPE: {info.type}</p>
      </Container>
  )
}

export default StatusInform;
